import { ICON_BASE_PATH } from "@/app/utils/config";

interface CardItemProps {
  item: any;
  first: boolean;
  setCount: (item: string) => number | undefined;
  onSelect: (value: string) => void;
}
export const CardItem = ({
  item,
  first,
  setCount,
  onSelect,
}: CardItemProps) => {
  return (
    <button
      type="button"
      key={item?.id}
      onClick={() => onSelect(item)}
      className={
        first ? "gx-action-card-dashboard-black" : "gx-action-card-dashboard"
      }
    >
      <p className="gx-card-name gx-p14-sb">{item?.name}</p>
      <div className="gx-card-right">
        <div className="gx-card-badge">
          <p className="gx-card-badge-text gx-p12-b">
            {setCount(item?.id) ? setCount(item?.id) : "0"}
          </p>
        </div>
        {first === false && (
          <img
            src={
              first
                ? `${ICON_BASE_PATH}right-arrow-white.svg`
                : `${ICON_BASE_PATH}right-arrow-black.svg`
            }
            alt="arrow"
          />
        )}
      </div>
    </button>
  );
};

export default CardItem;
